import { format, isValid, parseISO, startOfMonth, startOfWeek } from 'date-fns'

import { Granularity } from '@/models/agentRunReport'

/** Django's TruncWeek, which the backend buckets on, starts weeks on Monday. */
const WEEK_STARTS_ON = 1

/** The start the backend will really query, so the picker shows the range the tiles counted. */
export function snapRangeStart(start: string, granularity: Granularity): string {
  const date = parseISO(start)
  if (!isValid(date)) return start
  if (granularity === Granularity.MONTH) return format(startOfMonth(date), 'yyyy-MM-dd')
  if (granularity === Granularity.WEEK) {
    return format(startOfWeek(date, { weekStartsOn: WEEK_STARTS_ON }), 'yyyy-MM-dd')
  }
  return start
}

/** `2026-09-01` / `2026-09` as an axis tick or a tooltip heading. */
export function formatPeriod(period: string, granularity: string, long = false): string {
  if (granularity === Granularity.MONTH) {
    return format(parseISO(`${period}-01`), 'MMM yyyy')
  }
  const date = parseISO(period)
  if (granularity === Granularity.WEEK) {
    return long ? `Week of ${format(date, 'MMM d, yyyy')}` : format(date, 'MMM d')
  }
  return format(date, long ? 'MMM d, yyyy' : 'MMM d')
}
